export default __webpack_public_path__ + "static/media/exit-blue.8ef600e5.svg";